import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { environment } from 'src/environments/environment';

interface User {
  name: string | undefined;
  email: string;
  from: string;
}

interface LocalStorageEvents {
  userId: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class UserBehaviorService {
  private user = new BehaviorSubject<User>({
    name: '',
    email: '',
    from: ''
  });
  selectedUser = this.user.asObservable();

  private localStorageEvents = new BehaviorSubject<LocalStorageEvents>({
    userId: false
  });

  localStorageEvents$ = this.localStorageEvents.asObservable();

  constructor(private http: HttpClient) {}

  urlApiManagement = environment.urlApiManagement;

  setUser(user: User) {
    const previousValue = this.user.getValue();

    if (previousValue.name === user.name && previousValue.email === user.email) {
      return;
    }

    this.user.next(user);
  }

  emitUserIdEvent(isEventEmitted: boolean): void {
    const previousValue = this.localStorageEvents.getValue();

    this.localStorageEvents.next({
      ...previousValue,
      userId: isEventEmitted
    });
  }

  resetLocalStorageEvent(): void {
    this.localStorageEvents.next({
      userId: false
    });
  }

  async fromBehavior() {
    let user: any;
    this.selectedUser.subscribe((value) => (user = value));

    if (user?.from === 'store') {
      const expiring: any = await this.checkExpiring(user.email).toPromise();
      if (expiring[0].expired_flag === 'N') {
        return await { name: user.name, email: user.email };
      } else {
        return null;
      }
    } else {
      return await { name: user.name, email: user.email };
    }
  }

  fromBehaviorObservable(): Observable<User | null> {
    return this.selectedUser.pipe(
      switchMap((user) => {
        if (user && user.from === 'msal') {
          return of(user);
        }

        if (user && user.from === 'store') {
          this.checkExpiring(user.email).pipe(
            map((expiring: any) => {
              if (expiring[0].expired_flag === 'N') {
                return of(user);
              } else {
                return of(null);
              }
            })
          );
        }

        return of(null);
      })
    );
  }

  checkExpiring(email: string) {
    const url = `${this.urlApiManagement}/api/v1/logins/expired/${email}`;
    return this.http.get(url);
  }
}
